/* eslint-disable no-unused-vars */
<template>
  <div class="main">
    <div class="list-bg">
      <!-- <img class='play' src="../assets/club-play.png" alt="" @click="play"> -->
      <img class="exploreTeam-back" :src="bkimg" alt="">
    </div>
    <!--  -->

    <!-- </div> -->
    <div class="contain">
      <div v-show="showVideo" class="videoBox">
         <!-- <video
        id="myVideo"
        class="video-js"
        >
        <source
            :src="base.videoUrl"
            type="video/mp4"
        >
        </video> -->
        <div style="font-size:22px;" @click="close">X</div>
      <video
        id="video"
        :src="base.videoUrl"
        controls = "true"
        poster="images.jpg"
        preload="auto"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="allow"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="width=100%; height=100%; object-fit:fill">
      </video>
      </div>
      <div class="contain-top">
        <img :src="base.clubImg" alt="">
        <div class="contain-top-word">{{base.clubImgDetail}}</div>
      </div>
      <div class="contain-middle">
        <img src="../assets/club-img2.png" alt="">
      </div>
      <div class="contain-bottom">
        <div class="contain-bottom-imgbox">
          <div class="contain-bottom-imgbox-item" v-for="(item,index) in imgs" :key="index" :style="{backgroundImage:'url('+item.bottomImg+')'}">
            <img :src="item.icon" alt="">
            <span style="font-size:20px;">{{item.title}}</span>
            <span>——</span>
            <span style="font-size:14px;padding:0 60px;">{{item.subTitle}}</span>
          </div>
        </div>
        <div class="contain-bottom-content">
          <div class="contain-bottom-item" v-for="(item,index) in lists" :key="index" >
            <div class="item-title">{{item.title}}</div>
            <div class="item-des">{{item.content}}</div>
            <div class="item-people"><img src="../assets/club-see.png" alt="">  {{item.clickNum}}</div>
          </div>
        </div>
      </div>
      <p class='more' @click='more' v-if='lists.length<total'>点击加载更多</p>
      <p class='more' v-else>没有更多了...</p>
    </div>
    <div class="contain2">
      <div class="contain2-title">极地俱乐部会员社群</div>
      <div class="contain2-des">扫码加入基地俱乐部小程序社群</div>
      <div class="contain2-code">
        <img :src="base.clubCode" alt="">
      </div>
      <div class="contain2-tip">微信扫码，马上加入</div>
    </div>
  </div>
</template>
<script>
import {getClubBase, getClubImgs, getClubList} from '@/api/club.js'
// import {getthemelist} from '@/api/theme.js'
import bkimg from '../assets/club-back.png'
export default {
  data () {
    return {
      showVideo: false,
      lists: [],
      imgs: [],
      base: {},
      querylist: {
        page: 1,
        limit: 15
      },
      total: undefined,
      bkimg: bkimg
    }
  },
  methods: {
    // initVideo () {
    //   console.log(3333333333333)
    //   // 初始化视频方法
    //   // eslint-disable-next-line no-undef
    //   // eslint-disable-next-line no-unused-vars
    //   // eslint-disable-next-line no-undef
    //   let myPlayer = this.$video(myVideo, {
    //   // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
    //     controls: true,
    //     // 自动播放属性,muted:静音播放
    //     autoplay: 'muted',
    //     // 建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
    //     preload: 'auto',
    //     // 设置视频播放器的显示宽度（以像素为单位）
    //     width: '800px',
    //     // 设置视频播放器的显示高度（以像素为单位）
    //     height: '400px'
    //   })
    // },
    play () {
      this.showVideo = true
    },
    close () {
      this.showVideo = false
    },
    // 点击加载更多
    more () {
      this.querylist.page += 1
      this.getlist()
    },
    // 跳转详情页
    gotodetal (id, img, title) {
      this.$router.push({
        name: 'PastReviewDetail',
        params: {
          id: id,
          img: img,
          title: title
        }
      })
    },
    getClubList () {
      getClubList(this.querylist).then(res => {
        this.lists = this.lists.concat(res.data.data.items)
        this.total = res.data.data.total
      })
    },
    getClubBase () {
      getClubBase().then(res => {
        this.base = res.data.data
      })
    },
    getClubImgs () {
      getClubImgs().then(res => {
        this.imgs = res.data.data.items
      })
    }

  },
  mounted () {
    this.lists = []
    if (this.$route.query.img) {
      this.bkimg = this.$route.query.img
    }
    this.initVideo()
  },
  created () {
    this.getClubList()
    this.getClubBase()
    this.getClubImgs()
  }
}
</script>
<style scoped>
.videoBox{
  position: absolute;
  width:1000px;
  height:300px;
}
.main{
      background-color:#f4f4f4;
      padding-bottom:1.5rem;
      width:100%;
  }
  .contain{
    width:80rem;
    background-color: #fff;
    padding-bottom:3.75rem;
    padding-top:24px;
    margin: -200px auto 0;
    position: relative;
  }
  .contain-top{
    width:1232px;
    height:490px;
    margin:0 auto;
    border:1px solid rgba(226, 226, 226, 1);
    margin-bottom:60px;
  }
  .contain-top-word{
    padding:30px;
    box-sizing: border-box;
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(67,74,81,1);
    cursor: default;
  }
  .contain-middle{
    width:1032px;
    height:93px;
    margin:0 auto;
    margin-bottom:49px;
  }
  .contain-bottom-imgbox{
    padding:0 24px 24px;
    box-sizing: border-box;
    border-bottom:1px solid rgba(226, 226, 226, 1);
    display:flex;
    justify-content: space-between;
  }
  .contain-bottom-imgbox-item{
    width:395px;
    height:312px;
    background-image: url('../assets/dachuan.png');
    background-repeat: no-repeat;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(255,255,255,1);
  }
  .contain-bottom-imgbox-item img{
    width:80px;
    height:80px;
    margin-bottom:18px;
  }
  .contain-bottom-content{
    display:flex;
    flex-flow:wrap;
  }
  .contain-bottom-item{
    width:640px;
    border-bottom:1px solid rgba(226, 226, 226, 1);
    padding:20px;
    box-sizing: border-box;
  }
  .item-title{
    font-size:18px;
    font-family:Source Han Sans CN;
    font-weight:400;
    color:rgba(0,0,0,1);
    margin-bottom:20px;
  }
  .item-des{
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(122,122,122,1);
    margin-bottom:32px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;  /*要显示的行数*/
    -webkit-box-orient: vertical;
    cursor:default;
  }
  .item-people{
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(141,141,141,1);
  }
  .item-people img{
    margin-top:3px;
  }
  .contain2{
    width:80rem;
    height:611px;
    background:url('../assets/club-contain2.png');
    margin: 0 auto;
    margin-top:24px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .contain2-title{
    font-size:22px;
    font-family:Source Han Sans CN;
    font-weight:400;
    color:rgba(0,0,0,1);
    margin-bottom:12px;
  }
  .contain2-des{
    font-size:16px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(122,122,122,1);
    margin-bottom:40px;
  }
  .contain2-code{
    width:219px;
    height:219px;
    border:1px solid rgba(226, 226, 226, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom:10px;
  }
  .contain2-tip{
    font-size:14px;
    font-family:Source Han Sans CN;
    font-weight:300;
    color:rgba(140,140,140,1);
  }
  .list-bg {
        width: 100%;
        height: 672px;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        position: relative;
    }
  .list-bg .play{
    width:52px;
    height: 52px;
    position: absolute;
    left:50%;
    top:54%;
    margin-left:-26px;
  }
.exploreTeam-back{
  width:100%;
  height:100%;
}
  .more{
    font-size: .875rem;
    color:#6a7176;
    font-style:italic;
    text-align: center;
    margin-top:5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/club.vue